/**
 * @desc 检查accessToken是否有效
 */
const URL = "/rantion-auth";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/accessToken/check`, {
      method: "GET",

      ...options,
    }),
  );
}
